/**
 * Pins a toolbar just below the sticky site header. Measures the header group (the first top-0 sticky
 * element in <body>) so the bar never hides underneath it, and sets data-stuck while pinned so the bar can
 * show a divider only when it is floating over the products.
 */
class SStickyBar extends HTMLElement {
  connectedCallback() {
    this.header = [...document.body.children].find((el) => el.classList.contains('sticky') && el.classList.contains('top-0'));
    this.updateOffset = () => {
      const offset = this.header ? Math.round(this.header.getBoundingClientRect().height) : 0;
      this.style.top = `${offset}px`;
      this.offset = offset;
      this.updateStuck();
    };
    this.updateStuck = () => {
      const stuck = window.scrollY > 0 && Math.round(this.getBoundingClientRect().top) <= (this.offset || 0) + 1;
      this.toggleAttribute('data-stuck', stuck);
    };
    this.onScroll = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.updateStuck();
      });
    };
    if (this.header && 'ResizeObserver' in window) {
      this.observer = new ResizeObserver(this.updateOffset);
      this.observer.observe(this.header);
    }
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.updateOffset, { passive: true });
    this.updateOffset();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.updateOffset);
    if (this.frame) cancelAnimationFrame(this.frame);
  }
}

if (!customElements.get('s-sticky-bar')) customElements.define('s-sticky-bar', SStickyBar);
